module.exports = __webpack_public_path__ + "img/phone.c9d43abd.svg";